import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import {
  getShipManagementList,
  getShipManagementDetail,
  getPaintCoating,
  getEquipmentMachinery,
  getStructureAndHull,
  getStores,
  postInventoryDetails,
  postAddInventoryDetails,
  getCertificate,
  getLRForm,
  getInventoyPerson,
} from "../Actions/ShipManagementAPI";
import {
  UploadHKC,
  UploadEUSSR,
  UploadDocument,
  UploadRevisionDocument,
  UploadFullManual,
  UploadInventoryDocument,
  UploadInventory,
  UploadFlagSoc,
  UploadIAPP, Uploadec, Uploadldafd, Uploadamp,
} from "../Actions/CommonAPI";
import { UpdatePoDetails } from "../Actions/AttachmentAPI";
import { getCompanynameList, getCompanyUsersList } from "../Actions/HelpersAPI";
import { showLoader, hideLoader } from "../Actions/PageLoaderAPI";
import AddIcon from "../UIComponents/AddIcon";
import DatePicker from "react-datepicker";
// import { Paginator } from 'primereact/paginator';
import Moment from "moment";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import swal from "sweetalert";

let user = JSON.parse(localStorage.getItem("currentUser"));
let searchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 25,
};

class ShipManagementEditItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLRFromApplicable: false,
      NotLRFromApplicable: false,
      hkcfile: "",
      eussrfile: "",
      fullManualfile: "",
      flagSocfile: "",
      iappfile: "",
      ecfile: '',
      ldafdfile: '',
      ampfile: '',
      revisionfile: "",
      inventoryfile: "",
      revisionFilename: "",
      poUploadFile: "",
      poUploadFileName: "",
      poUploadSomeFailItem: [],
      inventoryFilename: "",
      hkcFilename: "",
      eussrFilename: "",
      fullManualFilename: "",
      flagSocFilename: "",
      iappFilename: "",
      ecFilename: '',
      ldafdFilename: '',
      ampFilename: '',
      ecFromDateOpen: false,
      ecToDateOpen: false,
      ldafdFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      PreparationDateOpen: false,
      DeliveryDateOpen: false,
      shipData: {
        shipId: 0,
        shipName: "",
        clientName: "",
        imoNo: "",
        flagName: "",
        className: "",
        shipEmail: "",
        dateOfBuild: "",
        poPullDate: "",
        vesselGroupEmail: "",
        invoiceForwardingEmail: "",
        phone1: "",
        phone2: "",
        hkcIssuedBy: "",
        hkcIssuedDate: "",
        fullmannualAttachmentName: "",
        fullmannualAttachmentGuid: "",
        flagSocAttachmentName: "",
        flagSocAttachmentGuid: "",
        eussrAttachmentName: "",
        eussrAttachmentGuid: "",
        hkcAttachmentName: "",
        hkcAttachmentGuid: "",
        iappAttachmentName: "",
        iappAttachmentGuid: "",
        ecAttachmentName: "",
        ecAttachmentGuid: "",
        ldafdAttachmentName: "",
        ldafdAttachmentGuid: "",
        ampAttachmentName: "",
        ampAttachmentGuid: "",
        hkcExpiryDate: "",
        euSSRIssuedBy: "",
        euSSRIssuedDate: "",
        euSSRExpiryDate: "",
        fullmannualIssuedDate: "",
        fullmannualIssuedBy: "",
        flagIssuedBy: "",
        flagIssuedDate: "",
        flagExpiryDate: "",
        iappIssuedBy: "",
        ecIssuedBy: "",
        ldafdIssuedBy: "",
        ampIssuedBy: "",
        iappIssuedDate: "",
        iappExpiryDate: "",
        ecIssuedDate: "",
        ecExpiryDate: "",
        ldafdIssuedDate: "",
        isDeleted: false,
        modifiedBy: user.email,
        shipUsers: [],
        attachmentName: "",
        attachmentGuid: "",
        inventoryName: "",
        inventoryGuid: "",
        hkccertificateId: "",
        eussrcertificateId: "",
        flagcertificateId: "",
        fullmannualcertificateId: "",
        iappcertificateId: "",
        eccertificateId: "",
        ldafdcertificateId: "",
        ampcertificateId: "",
        designatedPerson: ""
      },
      file: "",
      activePagePaintCoating: 0,
      activePageEquipment: 0,
      activePageStructure: 0,
      activePageStore: 0,
      rows: 5,
      fleetManager: "",
      technicalSuperintendent: "",
      technicalExecutive: "",
      paintAndCoating: [],
      equipmentAndMachinery: [],
      structureAndHull: [],
      store: [],
      isActive: false,
      persons: [],
      lrForm: {
        shipLrFormId: 0,
        vesselName: "",
        distinctiveNo: "",
        portOfRegistry: "",
        typeOfVessel: "",
        grossTonnage: "",
        imonumber: "",
        nameOfShipBuilder: "",
        nameOfShipOwner: "",
        dateOfDelivery: "",
        ihmInventoryNumber: "",
        issueNumber: "",
        isIhmDeveloped: false,
        nameOfPreparer: "",
        initialOfPreparer: "",
        companyOfPreparer: "",
        addressOfPreparer: "",
        positionOfPreparer: "",
        dateOfPreparation: "",
        modifiedBy: user.email,
      },
      deleteInventories: {
        shipId: 0,
        paintAndCoating: [],
        equipmentAndMachinery: [],
        structureAndHull: [],
        store: [],
      },
      revise: true,
      LRFormdata: true,
      isMobile: false,
      isGalaxyMobile: false,
    };
    this.handleCompanyInputChange = this.handleCompanyInputChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.openEnrollmentDatePicker = this.openEnrollmentDatePicker.bind(this);
    this.openPODatePicker = this.openPODatePicker.bind(this);
    this.openHKCFromDatePicker = this.openHKCFromDatePicker.bind(this);
    this.openEUSSRFromDatePicker = this.openEUSSRFromDatePicker.bind(this);
    this.openFlagSocFromDatePicker = this.openFlagSocFromDatePicker.bind(this);
    this.openHKCToDatePicker = this.openHKCToDatePicker.bind(this);
    this.openEUSSRToDatePicker = this.openEUSSRToDatePicker.bind(this);
    this.openFlagSocToDatePicker = this.openFlagSocToDatePicker.bind(this);
    this.openIHMFromDatePicker = this.openIHMFromDatePicker.bind(this);
    this.handleEnrollmentDateChange =
      this.handleEnrollmentDateChange.bind(this);
    this.handlePODateChange = this.handlePODateChange.bind(this);
    this.handleHKCFromDateChange = this.handleHKCFromDateChange.bind(this);
    this.handleHKCToDateChange = this.handleHKCToDateChange.bind(this);
    this.handleEUSSRFromDateChange = this.handleEUSSRFromDateChange.bind(this);
    this.handleEUSSRToDateChange = this.handleEUSSRToDateChange.bind(this);
    this.handleFlagSocFromDateChange =
      this.handleFlagSocFromDateChange.bind(this);
    this.handleFlagSocToDateChange = this.handleFlagSocToDateChange.bind(this);
    this.handleIHMFromDateChange = this.handleIHMFromDateChange.bind(this);
    this.UpdateData = this.UpdateData.bind(this);
    this.handlePaintCoatingPageChange =
      this.handlePaintCoatingPageChange.bind(this);
    this.handleEquipmentPageChange = this.handleEquipmentPageChange.bind(this);
    this.handleStructurePageChange = this.handleStructurePageChange.bind(this);
    this.handleStoresPageChange = this.handleStoresPageChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, CompanyName } = this.props;
    const { params } = match;
    const { id } = params;
    if (id) {
      this.state.deleteInventories.shipId = parseInt(id);
      this.setState({});
    }
    dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    dispatch(getShipManagementDetail(id));
    dispatch(getCertificate(id));
    dispatch(getCompanynameList());
    dispatch(getCompanyUsersList(CompanyName));
    dispatch(getPaintCoating(id));
    dispatch(getEquipmentMachinery(id));
    dispatch(getStructureAndHull(id));
    dispatch(getStores(id));
    dispatch(getLRForm(id));
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
    ;
  }
  resize = () => {
    if (window.innerWidth < 1007) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };


  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      attachmentDetail,
      inventoryDetail,
      ShipDetails,
      CertificateDetails,
      LRForm,
      InventoryPerson,
      HKCAttachment,
      EUSSRAttachment,
      FullManualAttachment,
      FlagSOCAttachment,
      IAPPAttachment,
      PaintCoatingList,
      EquipmentMachineryList,
      StructureHullList,
      StoreList,
      ECAttachment,
      AMPAttachment,
      LDSFAAttachment
    } = nextProps;
    if (ShipDetails && ShipDetails !== "") {
      prevState.shipData.shipId = ShipDetails.shipId;
      prevState.shipData.shipName = ShipDetails.shipName;
      prevState.shipData.clientName = ShipDetails.companyName;
      prevState.shipData.dateOfBuild = ShipDetails.dateOfBuild;
      prevState.shipData.poPullDate = ShipDetails.pullDate;
      prevState.shipData.imoNo = ShipDetails.imoNo;
      prevState.shipData.flagName = ShipDetails.flag;
      prevState.shipData.className = ShipDetails.class;
      prevState.shipData.shipEmail = ShipDetails.shipEmail;
      prevState.shipData.vesselGroupEmail = ShipDetails.vesselGroupEmail;
      prevState.shipData.designatedPerson = ShipDetails.designatedPerson ? ShipDetails.designatedPerson : "";
      prevState.shipData.invoiceForwardingEmail =
        ShipDetails.invoiceForwardingEmail;
      prevState.shipData.phone1 = ShipDetails.phone1;
      prevState.shipData.phone2 = ShipDetails.phone2;
      prevState.shipData.modifiedBy = ShipDetails.modifiedBy;
      prevState.fleetManager = ShipDetails.fleetManager;
      prevState.technicalSuperintendent = ShipDetails.technicalSuperintendent;
      prevState.technicalExecutive = ShipDetails.technicalExecutive;
      let Users = [
        {
          userName: ShipDetails.fleetManager,
          role: "fleetmanager",
        },
        {
          userName: ShipDetails.technicalSuperintendent,
          role: "superintendent",
        },
        {
          userName: ShipDetails.technicalExecutive,
          role: "technicalexecutive",
        },
      ];
      prevState.shipData.shipUsers = Users;
      // prevState.shipData.flagIssuedBy = ShipDetails.flagIssuedBy;
      // prevState.shipData.flagIssuedDate = ShipDetails.flagIssuedDate;
      // prevState.shipData.flagExpiryDate = ShipDetails.flagExpiryDate;
      // prevState.shipData.hkcIssuedBy = ShipDetails.hkcIssuedBy;
      // prevState.shipData.hkcIssuedDate = ShipDetails.hkcIssuedDate;
      // prevState.shipData.hkcExpiryDate = ShipDetails.hkcExpiryDate;
      // prevState.shipData.hkcAttachmentName = ShipDetails.hkcAttachmentName;
      // prevState.shipData.hkcAttachmentGuid = ShipDetails.hkcAttachmentGuid;
      // prevState.shipData.eussrAttachmentName = ShipDetails.eussrAttachmentName;
      // prevState.shipData.eussrAttachmentGuid = ShipDetails.eussrAttachmentGuid;
      // prevState.shipData.euSSRIssuedBy = ShipDetails.euSSRIssuedBy;
      // prevState.shipData.euSSRIssuedDate = ShipDetails.euSSRIssuedDate;
      // prevState.shipData.euSSRExpiryDate = ShipDetails.euSSRExpiryDate;
      // prevState.shipData.fullmannualAttachmentName = ShipDetails.fullmannualAttachmentName;
      // prevState.shipData.fullmannualAttachmentGuid = ShipDetails.fullmannualAttachmentGuid;
      // prevState.shipData.flagSocAttachmentName = ShipDetails.flagSocAttachmentName;
      // prevState.shipData.flagSocAttachmentGuid = ShipDetails.flagSocAttachmentGuid;
      // prevState.shipData.fullmannualIssuedDate = ShipDetails.fullmannualIssuedDate;
      // prevState.hkcFilename = ShipDetails.hkcAttachmentName;
      // prevState.eussrFilename = ShipDetails.eussrAttachmentName;
      // prevState.fullManualFilename = ShipDetails.fullmannualAttachmentName;
      // prevState.flagSocFilename = ShipDetails.flagSocAttachmentName;
      dispatch({ type: "getShipManagementDetailSuccess", data: "" });
    }

    if (CertificateDetails && CertificateDetails !== "") {
      dispatch({ type: "getCertificateSuccess", data: "" });
      CertificateDetails &&
        CertificateDetails.certificates.map((item) => {
          if (item.certificateType === "hkc") {
            return (
              (prevState.shipData.hkcIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.hkcIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.shipData.hkcExpiryDate = item.expiryDate
                ? item.expiryDate
                : ""),
              (prevState.shipData.hkcAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.hkcAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.hkcFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.hkccertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "eussr") {
            return (
              (prevState.shipData.eussrAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.eussrAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.shipData.euSSRIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.euSSRIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.shipData.euSSRExpiryDate = item.expiryDate
                ? item.expiryDate
                : ""),
              (prevState.eussrFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.eussrcertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "flagsoc") {
            return (
              (prevState.shipData.flagIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.flagIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.shipData.flagExpiryDate = item.expiryDate
                ? item.expiryDate
                : ""),
              (prevState.shipData.flagSocAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.flagSocAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.flagSocFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.flagcertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "initialfullmannual") {
            return (
              (prevState.shipData.fullmannualAttachmentName =
                item.attachmentName ? item.attachmentName : ""),
              (prevState.shipData.fullmannualAttachmentGuid =
                item.attachmentGuid ? item.attachmentGuid : ""),
              (prevState.shipData.fullmannualIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.fullmannualIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.fullManualFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.fullmannualcertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "iapp") {
            return (
              (prevState.shipData.iappAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.iappAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.shipData.iappIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.iappIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.shipData.iappExpiryDate = item.expiryDate
                ? item.expiryDate
                : ""),
              (prevState.iappFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.iappcertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "exemptioncertificate") {
            return (
              (prevState.shipData.ecAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.ecAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.shipData.ecIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.ecIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.shipData.ecExpiryDate = item.expiryDate
                ? item.expiryDate
                : ""),
              (prevState.ecFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.eccertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "asbestosfreedeclaration") {
            return (
              (prevState.shipData.ldafdAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.ldafdAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.shipData.ldafdIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.shipData.ldafdIssuedDate = item.issuedDate
                ? item.issuedDate
                : ""),
              (prevState.shipData.ldafdExpiryDate = item.expiryDate
                ? item.expiryDate
                : ""),
              (prevState.ldafdFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.ldafdcertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
          if (item.certificateType === "asbestosplan") {
            return (
              (prevState.shipData.ampAttachmentName = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.ampAttachmentGuid = item.attachmentGuid
                ? item.attachmentGuid
                : ""),
              (prevState.shipData.ampIssuedBy = item.issuedBy
                ? item.issuedBy
                : ""),
              (prevState.ampFilename = item.attachmentName
                ? item.attachmentName
                : ""),
              (prevState.shipData.ampcertificateId = item.certificateId
                ? item.certificateId
                : 0)
            );
          }
        });
    }

    if (LRForm && LRForm !== "") {
      prevState.LRFormdata = false;
      prevState.lrForm = LRForm;
      prevState.isLRFromApplicable = LRForm.isApplicable === true ? true : false;
      prevState.NotLRFromApplicable = LRForm.isApplicable === false ? true : false;
      if (LRForm.isApplicable === true) {
        $("#LRFromApplicable").addClass("show")
      } else {
        $("#LRFromApplicable").removeClass("show")
      }
      dispatch(getInventoyPerson(LRForm.shipLrFormId));
      dispatch({ type: "getLRFormSuccess", data: "" });
    }

    if (InventoryPerson && InventoryPerson !== "") {
      prevState.persons = InventoryPerson;
      dispatch({ type: "getInventoryPersonSuccess", data: "" });
    }

    if (HKCAttachment) {
      prevState.shipData.hkcAttachmentName = HKCAttachment.FileName;
      prevState.shipData.hkcAttachmentGuid = HKCAttachment.Guid;
      dispatch({ type: "AttachmentUploadHKCSuccess", data: "" });
    }
    if (EUSSRAttachment) {
      prevState.shipData.eussrAttachmentName = EUSSRAttachment.FileName;
      prevState.shipData.eussrAttachmentGuid = EUSSRAttachment.Guid;
      dispatch({ type: "AttachmentUploadEUSSRSuccess", data: "" });
    }
    if (FullManualAttachment) {
      prevState.shipData.fullmannualAttachmentName =
        FullManualAttachment.FileName;
      prevState.shipData.fullmannualAttachmentGuid = FullManualAttachment.Guid;
      dispatch({ type: "AttachmentUploadFullManualSuccess", data: "" });
    }
    if (FlagSOCAttachment) {
      prevState.shipData.flagSocAttachmentName = FlagSOCAttachment.FileName;
      prevState.shipData.flagSocAttachmentGuid = FlagSOCAttachment.Guid;
      dispatch({ type: "AttachmentUploadFlagSOCSuccess", data: "" });
    }
    if (IAPPAttachment && IAPPAttachment !== "") {
      prevState.shipData.iappAttachmentName = IAPPAttachment.FileName;
      prevState.shipData.iappAttachmentGuid = IAPPAttachment.Guid;
      dispatch({ type: "AttachmentUploadIAPPSuccess", data: "" });
    }
    if (ECAttachment && ECAttachment !== "") {
      prevState.shipData.ecAttachmentName = ECAttachment.FileName;
      prevState.shipData.ecAttachmentGuid = ECAttachment.Guid;
      dispatch({ type: "AttachmentUploadecSuccess", data: "" })
    }
    if (LDSFAAttachment && LDSFAAttachment !== "") {
      prevState.shipData.ldafdAttachmentName = LDSFAAttachment.FileName;
      prevState.shipData.ldafdAttachmentGuid = LDSFAAttachment.Guid;
      dispatch({ type: "AttachmentUploadldafdSuccess", data: "" })
    }
    if (AMPAttachment && AMPAttachment !== "") {
      prevState.shipData.ampAttachmentName = AMPAttachment.FileName;
      prevState.shipData.ampAttachmentGuid = AMPAttachment.Guid;
      dispatch({ type: "AttachmentUploadampSuccess", data: "" })
    }

    if (attachmentDetail) {
      prevState.shipData.attachmentName = attachmentDetail.FileName;
      prevState.shipData.attachmentGuid = attachmentDetail.Guid;
      dispatch({ type: "AttachmentUploadSuccess", data: "" });
    }
    if (inventoryDetail) {
      prevState.shipData.inventoryName = inventoryDetail.FileName;
      prevState.shipData.inventoryGuid = inventoryDetail.Guid;
      dispatch({ type: "InventoryUploadSuccess", data: "" });
    }
    if (prevState.hkcfile !== "") {
      dispatch(UploadHKC(prevState.hkcfile));
      prevState.hkcfile = "";
    }
    if (prevState.eussrfile !== "") {
      dispatch(UploadEUSSR(prevState.eussrfile));
      prevState.eussrfile = "";
    }
    if (prevState.fullManualfile !== "") {
      dispatch(UploadFullManual(prevState.fullManualfile));
      prevState.fullManualfile = "";
    }
    if (prevState.flagSocfile !== "") {
      dispatch(UploadFlagSoc(prevState.flagSocfile));
      prevState.flagSocfile = "";
    }
    if (prevState.iappfile !== "") {
      dispatch(UploadIAPP(prevState.iappfile));
      prevState.iappfile = "";
    }
    if (prevState.ampfile !== "") {
      dispatch(Uploadamp(prevState.ampfile));
      prevState.ampfile = "";
    }
    if (prevState.ldafdfile !== "") {
      dispatch(Uploadldafd(prevState.ldafdfile));
      prevState.ldafdfile = "";
    }
    if (prevState.ecfile !== "") {
      dispatch(Uploadec(prevState.ecfile));
      prevState.ecfile = "";
    }
    if (prevState.revisionfile !== "") {
      dispatch(UploadDocument(prevState.revisionfile));
      prevState.revisionfile = "";
    }
    if (prevState.inventoryfile !== "") {
      dispatch(UploadInventoryDocument(prevState.inventoryfile));
      prevState.inventoryfile = "";
    }
    if (PaintCoatingList) {
      prevState.paintAndCoating = PaintCoatingList.map((f) => {
        let paint = {
          paintAndCoatingId: f.paintAndCoatingId,
          name: f.name,
          application: f.application,
          location: f.location,
          material: f.material,
          remarks: f.remarks,
          quantity: f.quantity,
          unit: f.unit,
          pchmchm: f.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return paint;
      });
    }
    if (EquipmentMachineryList) {
      prevState.equipmentAndMachinery = EquipmentMachineryList.map((g) => {
        let equip = {
          equipmentAndMachineryId: g.equipmentAndMachineryId,
          name: g.name,
          material: g.material,
          location: g.location,
          remarks: g.remarks,
          parts: g.parts,
          quantity: g.quantity,
          unit: g.unit,
          pchmchm: g.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return equip;
      });
    }
    if (StructureHullList) {
      prevState.structureAndHull = StructureHullList.map((h) => {
        let structure = {
          structureAndHullId: h.structureAndHullId,
          name: h.name,
          material: h.material,
          location: h.location,
          remarks: h.remarks,
          parts: h.parts,
          quantity: h.quantity,
          unit: h.unit,
          pchmchm: h.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return structure;
      });
    }
    if (StoreList) {
      prevState.store = StoreList.map((i) => {
        let store = {
          storeId: i.storeId,
          name: i.name,
          material: i.material,
          location: i.location,
          remarks: i.remarks,
          parts: i.parts,
          quantity: i.quantity,
          unit: i.unit,
          pchmchm: i.pchmchm,
          isDeleted: false,
          isUpdated: true,
          createdBy: user.email,
          modifiedBy: user.email,
        };
        return store;
      });
    }
    // if (PaintAndCoatingList) {
    //     prevState.paintAndCoating = PaintCoatingList.map(f => {
    //         let paint = {
    //             paintAndCoatingId: f.paintAndCoatingId,
    //             name: f.name,
    //             application: f.application,
    //             location: f.location,
    //             remarks: f.remarks,
    //             quantity: f.quantity,
    //             unit: f.unit,
    //             pchmchm: f.pchmchm,
    //             isDeleted: false,
    //             isUpdated: true,
    //             createdBy: "",
    //             modifiedBy: ""
    //         };
    //         return paint;
    //     });
    // }
    // if (EquipmentAndMachineryList) {
    //     prevState.equipmentAndMachinery = EquipmentMachineryList.map(g => {
    //         let equip = {
    //             equipmentAndMachineryId: g.equipmentAndMachineryId,
    //             name: g.name,
    //             material: g.material,
    //             location: g.location,
    //             remarks: g.remarks,
    //             parts: g.parts,
    //             quantity: g.quantity,
    //             unit: g.unit,
    //             pchmchm: g.pchmchm,
    //             isDeleted: false,
    //             isUpdated: true,
    //             createdBy: "",
    //             modifiedBy: ""
    //         }
    //         return equip;
    //     });
    // }
    // if (StructureAndHullList) {
    //     prevState.structureAndHull = StructureHullList.map(h => {
    //         let structure = {
    //             structureAndHullId: h.structureAndHullId,
    //             name: h.name,
    //             material: h.material,
    //             location: h.location,
    //             remarks: h.remarks,
    //             parts: h.parts,
    //             quantity: h.quantity,
    //             unit: h.unit,
    //             pchmchm: h.pchmchm,
    //             isDeleted: false,
    //             isUpdated: true,
    //             createdBy: "",
    //             modifiedBy: ""
    //         }
    //         return structure;
    //     });
    // }
    // if (StoreAndList) {
    //     prevState.store = StoreList.map(i => {
    //         let store = {
    //             storeId: i.storeId,
    //             name: i.name,
    //             material: i.material,
    //             location: i.location,
    //             remarks: i.remarks,
    //             parts: i.parts,
    //             quantity: i.quantity,
    //             unit: i.unit,
    //             pchmchm: i.pchmchm,
    //             isDeleted: false,
    //             isUpdated: true,
    //             createdBy: "",
    //             modifiedBy: ""
    //         }
    //         return store;
    //     });
    // }
  }

  postPullDate = () => {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    let data = {
      shipId: parseInt(id),
      pullDate: this.state.shipData.poPullDate
        ? this.state.shipData.poPullDate
        : "",
    };
    let url = `${API.pullDate}`;
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "postPullDateSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postPullDateFailure",
          error: "ERROR",
        });
      });
  };

  ReviseData = () => {
    var revise = 0;
    const { dispatch } = this.props;
    this.state.revise = false;
    this.setState({});
    let inventory = {
      shipId: this.state.shipData.shipId,
      paintAndCoating: this.state.paintAndCoating,
      equipmentAndMachinery: this.state.equipmentAndMachinery,
      structureAndHull: this.state.structureAndHull,
      store: this.state.store,
    };
    let upload = {
      shipId: this.state.shipData.shipId,
      attachmentName: this.state.shipData.attachmentName,
      attachmentGuid: this.state.shipData.attachmentGuid,
    };
    let inventoryDocument = {
      shipId: this.state.shipData.shipId,
      attachmentName: this.state.shipData.inventoryName,
      attachmentGuid: this.state.shipData.inventoryGuid,
    };
    if (
      inventory.paintAndCoating.length !== 0 ||
      inventory.equipmentAndMachinery.length !== 0 ||
      inventory.structureAndHull.length !== 0 ||
      inventory.store.length !== 0
    ) {
      revise += 1;
      dispatch(postInventoryDetails(inventory, true));
    }
    if (
      this.state.shipData.inventoryName &&
      this.state.shipData.inventoryGuid
    ) {
      revise += 1;
      dispatch(UploadInventory(inventoryDocument));
    }
    if (
      this.state.shipData.attachmentName &&
      this.state.shipData.attachmentGuid
    ) {
      revise += 1;
      dispatch(UploadRevisionDocument(upload));
    }
    if (revise == 0) {
      swal('Error!', 'Please enter a details, before revise ', 'warning');
    }
  };

  AddInventory() {
    var check = 0;
    const { dispatch } = this.props;
    let inventory = {
      shipId: this.state.shipData.shipId,
      paintAndCoating: this.state.paintAndCoating,
      equipmentAndMachinery: this.state.equipmentAndMachinery,
      structureAndHull: this.state.structureAndHull,
      store: this.state.store,
    };
    if (
      inventory.paintAndCoating.length !== 0 ||
      inventory.equipmentAndMachinery.length !== 0 ||
      inventory.structureAndHull.length !== 0 ||
      inventory.store.length !== 0
    ) {
      check += 1;
      dispatch(postAddInventoryDetails(inventory, true));
    }
    if (check == 0) {
      swal('Error!', 'Please enter a details, before adding inventory ', 'warning');
    }
  }

  UploadPoDetailsDocument = (e) => {
    const { dispatch, match } = this.props;
    const { id } = match.params;
    const userDetails = localStorage.getItem("currentUser");
    let userToken = JSON.parse(userDetails);
    let url = `${API.poUpload}?shipId=${id}`;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + userToken.accessToken);

    var formdata = new FormData();
    formdata.append("file", this.state.poUploadFile);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    dispatch(showLoader());
    // axios
    //   .post(url,formdata)

    fetch(
      `${API.poUpload}?shipId=${id}`,
      requestOptions
    )
      .then(async (response) => {
        let dataObj = {
          data: await response.json(),
          status: response.status,
        };
        return dataObj;
      })
      .then((result) => {
        console.log("ResponseUpload", result);
        if (result.status === 200) {
          if (result.data.noPoMissed === true) {
            dispatch(hideLoader());
            toast.success("Upload Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            this.setState({});
          } else {
            dispatch(hideLoader());
            confirmAlert({
              message: "POs from Exceptional supplier",
              buttons: [
                {
                  label: "Ok",
                  onClick: () => { },
                },
              ],
              childrenElement: () => (
                <div>
                  {result.data.posFromExceptionalSupliers.map((i) => (
                    <p>{i}</p>
                  ))}
                </div>
              ),
            });
          }
        } else {
          dispatch(hideLoader());
          confirmAlert({
            message: result.data.errorDescription ?? "Failed to upload.",
            buttons: [
              {
                label: "Ok",
                onClick: () => { },
              },
            ],
          });
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        console.log("error", error);
      });
  };

  postData = () => {
    let containsData = 0;
    let nodata = 0;
    let count = this.state.persons.map((item, index) => {
      if (!item.isDeleted) {
        if (item.name?.trim() !== "" && item.position?.trim() !== "" && item.initials?.trim() !== "" && $(`#startDateId${index}`).text() !== "Invalid date" && $(`#startDateId${index}`).text().length > 0 && $(`#endDateId${index}`).text() !== "Invalid date") {
          containsData = containsData + 1;
        } else {
          nodata = nodata + 1;
        }
      }
    })
    if (nodata > 0) {
      $("#InventoryTableErrMsg").text("Please fill all the valid and mandatory fields");
    } else {
      this.UpdateData();
      $("#InventoryTableErrMsg").text("");
    }
  }

  UpdateData = () => {
    if (
      this.state.revise &&
      (this.state.shipData.inventoryName ||
        this.state.paintAndCoating.length ||
        this.state.equipmentAndMachinery.length ||
        this.state.structureAndHull.length ||
        this.state.store.length)
    ) {
      confirmAlert({
        message:
          "It seems like there are some data in inventory, Are you sure want to proceed without revise ?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              this.UpdateData1();
            },
          },
          {
            label: "No",
            onClick: () => { },
          },
        ],
      });
    } else {
      this.UpdateData1();
    }
  };

  UpdateData1() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    if (this.state.shipData.shipName !== "" && this.state.shipData.dateOfBuild !== "" && this.state.shipData.poPullDate !== "" && this.state.shipData.className !== "" && this.state.shipData.flagName !== "" && this.state.shipData.imoNo !== "") {
      if (/* this.state.shipData.hkcAttachmentName !== "" &&  */this.state.shipData.shipEmail !== "" /* && this.state.shipData.hkcIssuedDate !== "" && this.state.shipData.hkcExpiryDate !== "" */) {
        if (this.state.NotLRFromApplicable === true || this.state.isLRFromApplicable === true) {
          this.state.shipData.modifiedBy = user.email || "";
          let url = `${API.postShip}`;
          let putData = {
            ...this.state.shipData,
            designatedPerson: this.state.shipData.designatedPerson.trim() ? this.state.shipData.designatedPerson : null,
          }
          axios
            .put(url, putData, {
              headers: {
                key: user.accessToken,
              },
            })
            .then((response) => {
              let data3 = {
                shipLrFormId: this.state.lrForm.shipLrFormId,
                shipId: parseInt(id),
                vesselName: this.state.lrForm.vesselName,
                distinctiveNo: this.state.lrForm.distinctiveNo,
                portOfRegistry: this.state.lrForm.portOfRegistry,
                typeOfVessel: this.state.lrForm.typeOfVessel,
                grossTonnage: this.state.lrForm.grossTonnage,
                imonumber: this.state.lrForm.imonumber,
                nameOfShipBuilder: this.state.lrForm.nameOfShipBuilder,
                nameOfShipOwner: this.state.lrForm.nameOfShipOwner,
                dateOfDelivery: this.state.lrForm.dateOfDelivery,
                ihmInventoryNumber: this.state.lrForm.ihmInventoryNumber,
                issueNumber: this.state.lrForm.issueNumber,
                isIhmDeveloped: this.state.lrForm.isIhmDeveloped,
                nameOfPreparer: this.state.lrForm.nameOfPreparer,
                initialOfPreparer: this.state.lrForm.initialOfPreparer,
                companyOfPreparer: this.state.lrForm.companyOfPreparer,
                addressOfPreparer: this.state.lrForm.addressOfPreparer,
                positionOfPreparer: this.state.lrForm.positionOfPreparer,
                dateOfPreparation: this.state.lrForm.dateOfPreparation,
                isApplicable: this.state.isLRFromApplicable === true ? true : false,
                createdBy: user.email,
              };
              if (this.state.LRFormdata === true) {
                let url3 = `${API.GetLRForm}`;
                axios
                  .post(url3, data3)
                  .then((result) => {
                    if (result.data) {
                      let data4 = {
                        shipLrFormId: result.data,
                        persons: this.state.persons,
                      };
                      let url4 = `${API.GetPersons}`;
                      axios
                        .put(url4, data4)
                        .then((result) => {
                          dispatch({
                            type: "postInventoryPersonSuccess",
                            data: result.data,
                          });
                        })
                        .catch((error) => {
                          dispatch({
                            type: "postInventoryPersonFailure",
                            error: "ERROR",
                          });
                        });
                    }
                    dispatch({
                      type: "postLRSuccess",
                      data: result.data,
                    });
                  })
                  .catch((error) => {
                    dispatch({
                      type: "postLRFailure",
                      error: "ERROR",
                    });
                  });
              } else {
                let url3 = `${API.GetLRForm}`;
                axios
                  .put(url3, data3)
                  .then((result) => {
                    if (result.data) {
                      let data4 = {
                        shipLrFormId: this.state.lrForm.shipLrFormId,
                        persons: this.state.persons,
                      };
                      let url4 = `${API.GetPersons}`;
                      axios
                        .put(url4, data4)
                        .then((result) => {
                          dispatch({
                            type: "postInventoryPersonSuccess",
                            data: result.data,
                          });
                        })
                        .catch((error) => {
                          dispatch({
                            type: "postInventoryPersonFailure",
                            error: "ERROR",
                          });
                        });
                    }
                    dispatch({
                      type: "postLRSuccess",
                      data: result.data,
                    });
                  })
                  .catch((error) => {
                    dispatch({
                      type: "postLRFailure",
                      error: "ERROR",
                    });
                  });
              }
              let data1 = {
                shipId: parseInt(id),
                certificates: [
                  {
                    certificateType: "hkc",
                    certificateId: this.state.shipData.hkccertificateId,
                    issuedDate: this.state.shipData.hkcIssuedDate,
                    expiryDate: this.state.shipData.hkcExpiryDate,
                    attachmentName: this.state.shipData.hkcAttachmentName,
                    attachmentGuid: this.state.shipData.hkcAttachmentGuid,
                    issuedBy: this.state.shipData.hkcIssuedBy,
                  },
                  {
                    certificateType: "eussr",
                    certificateId: this.state.shipData.eussrcertificateId,
                    issuedDate: this.state.shipData.euSSRIssuedDate,
                    expiryDate: this.state.shipData.euSSRExpiryDate,
                    attachmentName: this.state.shipData.eussrAttachmentName,
                    attachmentGuid: this.state.shipData.eussrAttachmentGuid,
                    issuedBy: this.state.shipData.euSSRIssuedBy,
                  },
                  {
                    certificateType: "flagsoc",
                    certificateId: this.state.shipData.flagcertificateId,
                    issuedDate: this.state.shipData.flagIssuedDate,
                    expiryDate: this.state.shipData.flagExpiryDate,
                    attachmentName: this.state.shipData.flagSocAttachmentName,
                    attachmentGuid: this.state.shipData.flagSocAttachmentGuid,
                    issuedBy: this.state.shipData.flagIssuedBy,
                  },
                  {
                    certificateType: "initialfullmannual",
                    certificateId: this.state.shipData.fullmannualcertificateId,
                    issuedDate: this.state.shipData.fullmannualIssuedDate,
                    expiryDate: "",
                    attachmentName: this.state.shipData.fullmannualAttachmentName,
                    attachmentGuid: this.state.shipData.fullmannualAttachmentGuid,
                    issuedBy: this.state.shipData.fullmannualIssuedBy,
                  },
                  {
                    certificateType: "iapp",
                    certificateId: this.state.shipData.iappcertificateId,
                    issuedBy: this.state.shipData.iappIssuedBy,
                    issuedDate: this.state.shipData.iappIssuedDate,
                    expiryDate: this.state.shipData.iappExpiryDate,
                    attachmentName: this.state.shipData.iappAttachmentName,
                    attachmentGuid: this.state.shipData.iappAttachmentGuid,
                  },
                  {
                    certificateType: "exemptioncertificate",
                    certificateId: this.state.shipData.eccertificateId,
                    issuedBy: this.state.shipData.ecIssuedBy,
                    issuedDate: this.state.shipData.ecIssuedDate,
                    expiryDate: this.state.shipData.ecExpiryDate,
                    attachmentName: this.state.shipData.ecAttachmentName,
                    attachmentGuid: this.state.shipData.ecAttachmentGuid
                  },
                  {
                    certificateType: "asbestosfreedeclaration",
                    certificateId: this.state.shipData.ldafdcertificateId,
                    issuedBy: this.state.shipData.ldafdIssuedBy,
                    issuedDate: this.state.shipData.ldafdIssuedDate,
                    expiryDate: null,
                    attachmentName: this.state.shipData.ldafdAttachmentName,
                    attachmentGuid: this.state.shipData.ldafdAttachmentGuid
                  },
                  {
                    certificateType: "asbestosplan",
                    certificateId: this.state.shipData.ampcertificateId,
                    issuedBy: this.state.shipData.ampIssuedBy,
                    issuedDate: null,
                    expiryDate: null,
                    attachmentName: this.state.shipData.ampAttachmentName,
                    attachmentGuid: this.state.shipData.ampAttachmentGuid
                  }
                ],
                modifiedBy: user.email,
              };
              let url1 = `${API.Certificates}`;
              axios
                .put(url1, data1)
                .then((res) => {
                  this.props.history.push("/Home/Management/Ship");
                  toast.success("Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  this.props.dispatch({ type: "ShowSidePan", data: false });
                  dispatch(getShipManagementList(searchData));
                  dispatch({
                    type: "postCertificateSuccess",
                    data: res.data,
                  });
                  // }
                })
                .catch((error) => {
                  dispatch({
                    type: "postCertificateFailure",
                    error: "ERROR",
                  });
                });
              dispatch({
                type: "putShipDetailsSuccess",
                data: response.data,
              });
            })
            .catch((error) => {
              dispatch({
                type: "putShipDetailsFailure",
                error: "ERROR",
              });
            });

        } else {
          swal("Error!", "Please select the LRFrom applicable type.", "warning");
        }
      }/* else if (this.state.shipData.hkcAttachmentName === "") {
          swal('Error!', 'HKC Attachment is mandatory', 'warning');
        }  else if (this.state.shipData.hkcIssuedDate === "") {
          swal('Error!', 'HKC Issued Date is mandatory', 'warning');
        } else if (this.state.shipData.hkcExpiryDate === "") {
          swal('Error!', 'HKC Expriry Date is mandatory', 'warning');
        } */ else if (this.state.shipData.shipEmail === "") {
        swal('Error!', 'Ship Email is mandatory', 'warning');
      }
    } else if (this.state.shipData.shipName === "") {
      swal('Error!', 'Ship Name is mandatory', 'warning');
    } else if (this.state.shipData.imoNo === "") {
      swal('Error!', 'IMO Number is mandatory', 'warning');
    } else if (this.state.shipData.flagName === "") {
      swal('Error!', 'Flag Name is mandatory', 'warning');
    } else if (this.state.shipData.className === "") {
      swal('Error!', 'Class Name is mandatory', 'warning');
    } else if (this.state.shipData.dateOfBuild === "") {
      swal('Error!', 'Enrollment Date is mandatory', 'warning');
    } else if (this.state.shipData.poPullDate === "") {
      swal('Error!', 'PO Pull Date is mandatory', 'warning');
    }
  }

  handleCompanyInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fleetManager") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "fleetmanager",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "technicalSuperintendent") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "superintendent",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "technicalExecutive") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "technicalexecutive",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "clientName") {
      this.props.dispatch(getCompanyUsersList(e.target.value));
      this.state.shipData[nodeName] = e.target.value;
      this.state.fleetManager = "";
      this.state.technicalSuperintendent = "";
      this.state.technicalExecutive = "";
      this.state.shipData.shipUsers = [];
    } else {
      this.state.shipData[nodeName] = e.target.value;
    }
    this.setState({});
  }
  handleRadioInputChange(e, name) {
    let nodeName = name;
    if (nodeName === "Yes") {
      $("#LRFromApplicable").addClass("show")
      this.setState({ isLRFromApplicable: true, NotLRFromApplicable: false });
    } else if (nodeName === "No") {
      $("#LRFromApplicable").removeClass("show")
      this.setState({ isLRFromApplicable: false, NotLRFromApplicable: true });
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "HKC") {
      this.state.hkcFilename = e.target.files[0].name;
      this.state.hkcfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "EUSSR") {
      this.state.eussrFilename = e.target.files[0].name;
      this.state.eussrfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "fullManual") {
      this.state.fullManualFilename = e.target.files[0].name;
      this.state.fullManualfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "SOC") {
      this.state.flagSocFilename = e.target.files[0].name;
      this.state.flagSocfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "IAPP") {
      this.state.iappFilename = e.target.files[0].name;
      this.state.iappfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "fileName") {
      this.state.revisionFilename = e.target.files[0].name;
      this.state.revisionfile = e.target.files[0];
      this.setState({});
      // this.props.dispatch(UploadDocument(e.target.files[0]));
    } else if (nodeName === "inventoryName") {
      this.state.inventoryFilename = e.target.files[0].name;
      this.state.inventoryfile = e.target.files[0];
      this.setState({});
      // this.props.dispatch(UploadInventoryDocument(e.target.files[0]));
    } else if (nodeName === "ec") {
      this.state.ecFilename = e.target.files[0].name;
      this.state.ecfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "ldafd") {
      this.state.ldafdFilename = e.target.files[0].name;
      this.state.ldafdfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "amp") {
      this.state.ampFilename = e.target.files[0].name;
      this.state.ampfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "poFile") {
      this.state.poUploadFileName = e.target.files[0].name;
      this.state.poUploadFile = e.target.files[0];
      this.setState({});
      // this.props.dispatch(UploadInventoryDocument(e.target.files[0]));
    } else {
      this.state.shipData[nodeName] = e.target.value;
      this.setState({});
    }
  }

  handleLRChange = (e) => {
    let nodeName = e.target.name;
    this.state.lrForm[nodeName] = e.target.value;
    this.setState({});
  };

  handleCheckBoxChange = (e) => {
    if (e.target.checked) {
      this.state.lrForm.isIhmDeveloped = true;
      this.setState({});
    } else {
      this.state.lrForm.isIhmDeveloped = false;
      this.setState({});
    }
  };

  handleAddEvent = (e) => {
    var person = {
      inventoryResponsiblePersonId: 0,
      name: "",
      position: "",
      initials: "",
      startDate: "",
      endDate: "",
      isDeleted: false,
      modifiedBy: user.email,
    };
    this.state.persons.push(person);
    this.setState(this.state.persons);
  };

  handleTableEvent = (e, index, field) => {
    this.state.persons[index][field] = e.target.outerText;
    this.setState({});
  };

  handleDeleteEvent = (e, index) => {
    confirmAlert({
      message: 'Are you sure want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.state.persons[index].isDeleted = true;
            this.setState({});
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    });
  };
  ClearInputPoFile = () => {
    this.state.poUploadFileName = "";
    this.state.poUploadFile = "";
    this.setState({});
  };
  ClearInput() {
    this.state.shipData.attachmentName = "";
    this.state.shipData.attachmentGuid = "";
    this.setState({ revisionFilename: "" });
    let clearData = { FileName: "", Guid: "" };
    this.props.dispatch({
      type: "AttachmentUploadSuccess",
      data: clearData,
    });
  }

  ClearInputs() {
    this.state.shipData.inventoryName = "";
    this.state.shipData.inventoryGuid = "";
    this.setState({ inventoryFilename: "" });
    let clearData = { FileName: "", Guid: "" };
    this.props.dispatch({
      type: "InventoryUploadSuccess",
      data: clearData,
    });
  }

  openHKCFromDatePicker() {
    this.setState({
      hkcFromDateOpen: !this.state.hkcFromDateOpen,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      ihmFromDateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
    });
  }

  openEUSSRFromDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: !this.state.eussrFromDateOpen,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      ihmFromDateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openHKCToDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: !this.state.hkcToDateOpen,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      ihmFromDateOpen: false,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openEUSSRToDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      eussrToDateOpen: !this.state.eussrToDateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openIHMFromDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: false,
      ihmFromDateOpen: !this.state.ihmFromDateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openEnrollmentDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      enrollmentDateOpen: !this.state.enrollmentDateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openPODatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      ihmFromDateOpen: false,
      enrollmentDateOpen: false,
      PODateOpen: !this.state.PODateOpen,
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openFlagSocFromDatePicker() {
    this.setState({
      flagSocFromDateOpen: !this.state.flagSocFromDateOpen,
      flagSocToDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openFlagSocToDatePicker() {
    this.setState({
      flagSocToDateOpen: !this.state.flagSocToDateOpen,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  }

  openiappFromDatePicker = () => {
    this.setState({
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappToDateOpen: false,
      iappFromDateOpen: !this.state.iappFromDateOpen,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  };

  openiappToDatePicker = () => {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: !this.state.iappToDateOpen,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false
    });
  };

  openecFromDatePicker = () => {
    this.setState({
      flagSocFromDateOpen: false,
      flagSocToDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ldafdFromDateOpen: false,
      ecToDateOpen: false,
      ecFromDateOpen: !this.state.ecFromDateOpen,
    });
  }

  openldafdFromDatePicker = () => {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      ldafdFromDateOpen: !this.state.ldafdFromDateOpen
    });
  }

  openecToDatePicker = () => {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      PODateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: !this.state.ecToDateOpen
    });
  }

  openDeliveryDatePicker = () => {
    this.setState({
      PreparationDateOpen: false,
      DeliveryDateOpen: !this.state.DeliveryDateOpen,
    });
  };

  openPreparationDatePicker = () => {
    this.setState({
      DeliveryDateOpen: false,
      PreparationDateOpen: !this.state.PreparationDateOpen,
    });
  };

  handleEnrollmentDateChange(date) {
    this.state.shipData.dateOfBuild = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      enrollmentDateOpen: false,
    });
  }

  handlePODateChange(date) {
    this.state.shipData.poPullDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      PODateOpen: false,
    });
  }

  handleHKCFromDateChange(date) {
    this.state.shipData.hkcIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      hkcFromDateOpen: false,
    });
  }

  handleHKCToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.hkcIssuedDate
    ) {
      this.state.shipData.hkcExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      hkcToDateOpen: false,
    });
  }

  handleEUSSRFromDateChange(date) {
    this.state.shipData.euSSRIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      eussrFromDateOpen: false,
    });
  }

  handleEUSSRToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.euSSRIssuedDate
    ) {
      this.state.shipData.euSSRExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      eussrToDateOpen: false,
    });
  }

  handleIHMFromDateChange(date) {
    this.state.shipData.fullmannualIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      ihmFromDateOpen: false,
    });
  }

  handleFlagSocFromDateChange(date) {
    this.state.shipData.flagIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      flagSocFromDateOpen: false,
    });
  }

  handleFlagSocToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.flagIssuedDate
    ) {
      this.state.shipData.flagExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      flagSocToDateOpen: false,
    });
  }

  handleiappFromDateChange = (date) => {
    this.state.shipData.iappIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      iappFromDateOpen: false,
    });
  };

  handleiappToDateChange = (date) => {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.iappIssuedDate
    ) {
      this.state.shipData.iappExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      iappToDateOpen: false,
    });
  };

  handleecFromDateChange = (date) => {
    this.state.shipData.ecIssuedDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      ecFromDateOpen: false,
    });
  }

  handleecToDateChange = (date) => {
    if (Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >= this.state.shipData.ecIssuedDate) {
      this.state.shipData.ecExpiryDate = Moment(new Date(Date.parse(date))).format(
        "YYYY-MM-DD"
      );
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      ecToDateOpen: false,
    });
  }

  handleldafdFromDateChange = (date) => {
    this.state.shipData.ldafdIssuedDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      ldafdFromDateOpen: false,
    });
  }


  handlePreparationDateChange = (date) => {
    this.state.lrForm.dateOfPreparation = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      PreparationDateOpen: false,
    });
  };

  handleDeliveryDateChange = (date) => {
    this.state.lrForm.dateOfDelivery = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      DeliveryDateOpen: false,
    });
  };

  handleBlur() {
    this.setState({
      flagSocToDateOpen: false,
      flagSocFromDateOpen: false,
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      enrollmentDateOpen: false,
      ihmFromDateOpen: false,
      iappFromDateOpen: false,
      iappToDateOpen: false,
      PODateOpen: false,
      PreparationDateOpen: false,
      ldafdFromDateOpen: false,
      ecFromDateOpen: false,
      ecToDateOpen: false,
      DeliveryDateOpen: false,
    });
  }

  ClearHKC = () => {
    const { dispatch } = this.props;
    this.state.shipData.hkcAttachmentName = "";
    this.state.shipData.hkcAttachmentGuid = "";
    this.state.shipData.hkcIssuedDate = "";
    this.state.shipData.hkcExpiryDate = "";
    this.setState({
      hkcFilename: "",
      hkcfile: "",
    });
  };

  ClearEUSSR = () => {
    const { dispatch } = this.props;
    this.state.shipData.eussrAttachmentName = "";
    this.state.shipData.eussrAttachmentGuid = "";
    this.state.shipData.euSSRIssuedDate = "";
    this.state.shipData.euSSRExpiryDate = "";
    this.setState({
      eussrfile: "",
      eussrFilename: "",
    });
  };

  ClearIHM = () => {
    const { dispatch } = this.props;
    this.state.shipData.fullmannualAttachmentName = "";
    this.state.shipData.fullmannualAttachmentGuid = "";
    this.state.shipData.fullmannualIssuedDate = "";
    this.setState({
      fullManualFile: "",
      fullManualFilename: "",
    });
  };

  ClearSOC = () => {
    const { dispatch } = this.props;
    this.state.shipData.flagSocAttachmentName = "";
    this.state.shipData.flagSocAttachmentGuid = "";
    this.state.shipData.flagIssuedDate = "";
    this.state.shipData.flagExpiryDate = "";
    this.setState({
      flagSocFilename: "",
      flagSocfile: "",
    });
  };

  ClearIAPP = () => {
    const { dispatch } = this.props;
    this.state.shipData.iappAttachmentName = "";
    this.state.shipData.iappAttachmentGuid = "";
    this.state.shipData.iappIssuedDate = "";
    this.state.shipData.iappExpiryDate = "";
    this.setState({
      iappFilename: "",
      iappfile: "",
    });
  };

  Clearamp = () => {
    const { dispatch } = this.props;
    this.state.shipData.ampAttachmentName = '';
    this.state.shipData.ampAttachmentGuid = '';
    this.setState({
      ampFilename: '',
      ampfile: ''
    });
  }

  Clearec = () => {
    const { dispatch } = this.props;
    this.state.shipData.ecAttachmentName = '';
    this.state.shipData.ecAttachmentGuid = '';
    this.state.shipData.ecIssuedDate = "";
    this.state.shipData.ecExpiryDate = "";
    this.setState({
      ecFilename: '',
      ecfile: ''
    });
  }

  Clearldafd = () => {
    const { dispatch } = this.props;
    this.state.shipData.ldafdAttachmentName = '';
    this.state.shipData.ldafdAttachmentGuid = '';
    this.state.shipData.ldafdIssuedDate = "";
    this.setState({
      ldafdFilename: '',
      ldafdfile: ''
    });
  }

  handlePaintCoatingPageChange(event) {
    this.setState({
      activePagePaintCoating: event.first,
    });
  }

  handleEquipmentPageChange(event) {
    this.setState({
      activePageEquipment: event.first,
    });
  }

  handleStructurePageChange(event) {
    this.setState({
      activePageStructure: event.first,
    });
  }

  handleStoresPageChange(event) {
    this.setState({
      activePageStore: event.first,
    });
  }

  toggleVisibility = () =>
    this.setState((prevState) => ({ isActive: !this.state.isActive }));

  render() {
    const { showSidePane, CompanyNames, CompanyUsers } = this.props;
    const { paintAndCoating, equipmentAndMachinery, structureAndHull, store } =
      this.state;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Basic Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Name</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipName"
                      value={this.state.shipData.shipName}
                      placeholder="Ship Name"
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  {/* <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                                        <label className="form-label" >Client Name</label><br></br>
                                        <input className="form-control" type="text" name="clientName" value={this.state.shipData.clientName} placeholder="Client Name" onChange={e => this.handleInputChange(e)}></input>
                                    </div> */}
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">IMO No</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      value={this.state.shipData.imoNo}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="IMO No"
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Flag</label>
                    <br></br>
                    <input
                      className="form-control"
                      placeholder="Flag"
                      name="flagName"
                      value={this.state.shipData.flagName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                    {/* <select className="form-control" name="flagName" value={this.state.shipData.flagName} onChange={e => this.handleInputChange(e)}>
                                            <option value="">Select Flag</option>
                                            <option value="India">India</option>
                                            <option value="Flag 1">Flag 1</option>
                                            <option value="Flag 2">Flag 2</option>
                                            <option value="Flag 3">Flag 3</option>
                                            <option value="Flag 4">Flag 4</option>
                                        </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Class</label>
                    <br></br>
                    <input
                      className="form-control"
                      placeholder="Class"
                      name="className"
                      value={this.state.shipData.className}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                    {/* <select className="form-control" name="className" value={this.state.shipData.className} onChange={e => this.handleInputChange(e)}>
                                            <option value="">Select Class</option>
                                            <option value="Cargo ship">Cargo ship</option>
                                            <option value="Class 1">Class 1</option>
                                            <option value="Class 2">Class 2</option>
                                            <option value="Class 3">Class 3</option>
                                            <option value="Class 4">Class 4</option>
                                        </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Enrollment Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={
                          this.state.shipData.dateOfBuild
                            ? Moment(
                              new Date(
                                Date.parse(this.state.shipData.dateOfBuild)
                              )
                            ).format("YYYY-MM-DD")
                            : ""
                        }
                        className="form-control date-picker"
                        placeholder="Enrollment Date"
                        name="enrollmentDate"
                      ></input>
                      <DatePicker
                        // selected={this.state.SelectedFromDate}
                        onChange={this.handleEnrollmentDateChange}
                        open={this.state.enrollmentDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openEnrollmentDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-4" : "col-lg-3"}>
                    <label className="form-label required">PO Pull Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={
                          this.state.shipData.poPullDate
                            ? Moment(
                              new Date(
                                Date.parse(this.state.shipData.poPullDate)
                              )
                            ).format("YYYY-MM-DD")
                            : ""
                        }
                        className="form-control date-picker"
                        placeholder="PO Pull Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handlePODateChange}
                        open={this.state.PODateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openPODatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-1 mt-3" : "col-lg-1 mt-3"}
                  >
                    <label className="form-label"></label>
                    <br></br>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.postPullDate()}
                    >
                      {" "}
                      Set{" "}
                    </button>
                  </div>
                </div>
              </div>

              <div className="search-filter-box pb-0">
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="panel-box">
                      <Accordion>
                        <Card
                          className={"MM-card-header"}
                          style={{ backgroundColor: "white" }}
                        >
                          <Accordion.Toggle
                            as={Card.Body}
                            style={{ cursor: "pointer" }}>
                            <h5
                              className="card-title ml-2 mt-2"
                              style={{ color: "092a51" }}>

                              <div className="row">
                                <span className="pl-3">LR Form</span>{" "}
                                <span className="pl-5">Is Applicable </span>
                                <div className="col-sm-3 d-flex">
                                  <input
                                    type="radio"
                                    name="LRFROM"
                                    checked={this.state.isLRFromApplicable}
                                    onChange={(e) =>
                                      this.handleRadioInputChange(e, "Yes")
                                    }
                                  ></input>
                                  <span className="ml-1">Yes</span>
                                  <label className="pl-4 m-0 d-flex">
                                    <input
                                      type="radio"
                                      name="LRFROM"
                                      checked={this.state.NotLRFromApplicable}
                                      onChange={(e) =>
                                        this.handleRadioInputChange(e, "No")
                                      }
                                    ></input>
                                    <span className="ml-1">No</span></label>
                                </div>

                              </div>
                            </h5>
                          </Accordion.Toggle>
                          <Accordion.Collapse className="" id="LRFromApplicable">
                            <div className="search-filter-box history-box mt-2">
                              <div
                                className="card mt-2 MM-card-header mb-0"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="card-body text-center"
                                  style={{
                                    padding: "0rem",
                                    backgroundColor: "#1E3A8A",
                                    color: "white",
                                  }}
                                >
                                  <h5
                                    className="card-title m-2"
                                    style={{ color: "092a51" }}
                                  >
                                    Inventory of Hazardous Materials
                                  </h5>
                                </div>
                              </div>
                              <div className="row search-filter-box">
                                <div className="col-lg-12">
                                  <strong style={{ fontSize: "20px" }}>
                                    Particulars of the Ship:{" "}
                                  </strong>
                                  <br></br>
                                  <i>
                                    <b>
                                      (Fields with a{" "}
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      are mandatory and must be completed in all
                                      cases.)
                                    </b>
                                  </i>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Ship/Vessel Name{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Ship/Vessel Name"
                                    name="vesselName"
                                    value={this.state.lrForm.vesselName}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Distinctive No. / Letters{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Distinctive No. / Letters"
                                    name="distinctiveNo"
                                    value={this.state.lrForm.distinctiveNo}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Port of Registry{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Port of Registry"
                                    name="portOfRegistry"
                                    value={this.state.lrForm.portOfRegistry}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Type of vessel{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Type of vessel"
                                    name="typeOfVessel"
                                    value={this.state.lrForm.typeOfVessel}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Gross Tonnage{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Gross Tonnage"
                                    name="grossTonnage"
                                    value={this.state.lrForm.grossTonnage}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    IMO Number{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="IMO Number"
                                    name="imonumber"
                                    value={this.state.lrForm.imonumber}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Name of Shipbuilder{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Name of Shipbuilder"
                                    name="nameOfShipBuilder"
                                    value={this.state.lrForm.nameOfShipBuilder}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Name of Shipowner{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Name of Shipowner"
                                    name="nameOfShipOwner"
                                    value={this.state.lrForm.nameOfShipOwner}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Date of Delivery{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div
                                    className="input-group add-on date datepicker"
                                    data-date-format="yyyy-mm-dd"
                                  >
                                    <input
                                      type="text"
                                      value={
                                        this.state.lrForm.dateOfDelivery
                                          ? Moment(
                                            new Date(
                                              Date.parse(
                                                this.state.lrForm
                                                  .dateOfDelivery
                                              )
                                            )
                                          ).format("YYYY-MM-DD")
                                          : ""
                                      }
                                      className="form-control date-picker"
                                      placeholder="Date of Delivery"
                                      name="POFromDate"
                                    ></input>
                                    <DatePicker
                                      onChange={this.handleDeliveryDateChange}
                                      open={this.state.DeliveryDateOpen}
                                      onClickOutside={this.handleBlur}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      popperPlacement="top-end"
                                      className="form-control date-picker w-5 hide-date"
                                    />
                                    <div
                                      className="input-group-btn calendar-icon"
                                      onClick={this.openDeliveryDatePicker}
                                    >
                                      <button
                                        className="btn btn-default"
                                        style={{ height: "100%" }}
                                      >
                                        <i className="fa fa-calendar mt-1"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    IHM Inventory Number{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="IHM Inventory Number"
                                    name="ihmInventoryNumber"
                                    value={this.state.lrForm.ihmInventoryNumber}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane
                                      ? "col-lg-6 mb-2"
                                      : "col-lg-4 mb-2"
                                  }
                                >
                                  <label className="form-label">
                                    Issue Number{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Issue Number"
                                    name="issueNumber"
                                    value={this.state.lrForm.issueNumber}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <label className="ml-3">
                                  This inventory was developed in accordance
                                  with the IMO Guidelines for the Development of
                                  the Inventory of Hazardous Materials.{" "}
                                </label>
                                <div
                                  className={
                                    showSidePane ? "col-lg-12" : "col-lg-12"
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    placeholder="Issue Number"
                                    name="isIhmDeveloped"
                                    checked={this.state.lrForm.isIhmDeveloped}
                                    onChange={(e) =>
                                      this.handleCheckBoxChange(e)
                                    }
                                  ></input>
                                  <span className="ml-3">
                                    If the IHM has been developed to cover
                                    additional requirements of the EU Ship
                                    Recycling Regulation (EU) 1257/2013 please
                                    check this box.{" "}
                                  </span>
                                </div>
                                <div className="col-lg-12 mt-3">
                                  <strong style={{ fontSize: "20px" }}>
                                    Initially prepared by:{" "}
                                  </strong>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Name <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Name"
                                    name="nameOfPreparer"
                                    value={this.state.lrForm.nameOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Company{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Company"
                                    name="companyOfPreparer"
                                    value={this.state.lrForm.companyOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Address{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Address"
                                    name="addressOfPreparer"
                                    value={this.state.lrForm.addressOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Position{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Position"
                                    name="positionOfPreparer"
                                    value={this.state.lrForm.positionOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Date <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div
                                    className="input-group add-on date datepicker"
                                    data-date-format="yyyy-mm-dd"
                                  >
                                    <input
                                      type="text"
                                      value={
                                        this.state.lrForm.dateOfPreparation
                                          ? Moment(
                                            new Date(
                                              Date.parse(
                                                this.state.lrForm
                                                  .dateOfPreparation
                                              )
                                            )
                                          ).format("YYYY-MM-DD")
                                          : ""
                                      }
                                      className="form-control date-picker"
                                      placeholder="Date"
                                      name="POFromDate"
                                    ></input>
                                    <DatePicker
                                      onChange={
                                        this.handlePreparationDateChange
                                      }
                                      open={this.state.PreparationDateOpen}
                                      onClickOutside={this.handleBlur}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      popperPlacement="top-end"
                                      className="form-control date-picker w-5 hide-date"
                                    />
                                    <div
                                      className="input-group-btn calendar-icon"
                                      onClick={this.openPreparationDatePicker}
                                    >
                                      <button
                                        className="btn btn-default"
                                        style={{ height: "100%" }}
                                      >
                                        <i className="fa fa-calendar mt-1"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    showSidePane ? "col-lg-6" : "col-lg-4"
                                  }
                                >
                                  <label className="form-label">
                                    Initials{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    placeholder="Initials"
                                    name="initialOfPreparer"
                                    value={this.state.lrForm.initialOfPreparer}
                                    onChange={(e) => this.handleLRChange(e)}
                                  ></input>
                                </div>
                                <div className="col-lg-12 mt-3">
                                  <strong style={{ fontSize: "20px" }}>
                                    Designated person(s) responsible for the
                                    inventory{" "}
                                  </strong>
                                </div>
                                <div className="col-lg-12 mt-2">
                                  <div className="row">
                                    <div className="col-lg-11">
                                      <table className="material-decalaration-table table table-responsive">
                                        <tr>
                                          <th>
                                            Name
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Position
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Initials
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Start Date
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                            <br></br>( YYYY-MM-DD )
                                          </th>
                                          <th>
                                            End date <br></br>( YYYY-MM-DD )
                                          </th>
                                        </tr>
                                        {this.state.persons &&
                                          this.state.persons.map(
                                            (item, index) => {
                                              if (!item.isDeleted) {
                                                return (
                                                  <tr>
                                                    <td
                                                      className="text-center"
                                                      contentEditable="true"
                                                      onBlur={(e) =>
                                                        this.handleTableEvent(
                                                          e,
                                                          index,
                                                          "name"
                                                        )
                                                      }
                                                    >
                                                      {item.name}
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      contentEditable="true"
                                                      onBlur={(e) =>
                                                        this.handleTableEvent(
                                                          e,
                                                          index,
                                                          "position"
                                                        )
                                                      }
                                                    >
                                                      {item.position}
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      contentEditable="true"
                                                      onBlur={(e) =>
                                                        this.handleTableEvent(
                                                          e,
                                                          index,
                                                          "initials"
                                                        )
                                                      }
                                                    >
                                                      {item.initials}
                                                    </td>
                                                    <td
                                                      id={"startDateId" + index}
                                                      className="text-center"
                                                      contentEditable="true"
                                                      onBlur={(e) =>
                                                        this.handleTableEvent(
                                                          e,
                                                          index,
                                                          "startDate"
                                                        )
                                                      }
                                                    >
                                                      {item.startDate
                                                        ? Moment(
                                                          new Date(
                                                            Date.parse(
                                                              item.startDate
                                                            )
                                                          )
                                                        ).format("YYYY-MM-DD")
                                                        : ""}
                                                    </td>
                                                    <td
                                                      id={"endDateId" + index}
                                                      className="text-center"
                                                      contentEditable="true"
                                                      onBlur={(e) =>
                                                        this.handleTableEvent(
                                                          e,
                                                          index,
                                                          "endDate"
                                                        )
                                                      }
                                                    >
                                                      {item.endDate
                                                        ? Moment(
                                                          new Date(
                                                            Date.parse(
                                                              item.endDate
                                                            )
                                                          )
                                                        ).format("YYYY-MM-DD")
                                                        : ""}
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                    >
                                                      <button
                                                        className="btn btn-primary text-uppercase txtht-btn blue text-center"
                                                        style={{
                                                          minHeight: "30px",
                                                        }}
                                                        onClick={(e) =>
                                                          this.handleDeleteEvent(
                                                            e,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        Delete
                                                      </button>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            }
                                          )}
                                      </table>
                                      <span id="InventoryTableErrMsg" className="spanErrMsg ml-2"></span>
                                    </div>
                                    <div className="col-lg-1">
                                      <button
                                        className="btn btn-primary text-uppercase txtht-btn blue"
                                        style={{ minHeight: "34px" }}
                                        type="submit"
                                        onClick={(e) => this.handleAddEvent(e)}
                                      >
                                        Add{" "}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>

              <div className="search-filter-box pb-0">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Certificates & Documents
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">HKC </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            id="files"
                            name="HKC"
                            style={{ marginRight: 40 }}
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.hkcFilename}
                      />
                      {this.state.hkcFilename ? (
                        <div class="input-group-append" style={{ cursor: "pointer" }}>
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearHKC()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">EUSSR </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            id="files"
                            name="EUSSR"
                            style={{ marginRight: 40 }}
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.eussrFilename}
                      />
                      {this.state.eussrFilename ? (
                        <div class="input-group-append" style={{ cursor: "pointer" }}>
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearEUSSR()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">IHM Full Manual </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            id="files"
                            style={{ marginRight: 40 }}
                            name="fullManual"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.fullManualFilename}
                      />
                      {this.state.fullManualFilename ? (
                        <div class="input-group-append" style={{ cursor: "pointer" }}>
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearIHM()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">HKC Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.hkcIssuedDate && Moment(
                          new Date(
                            Date.parse(this.state.shipData.hkcIssuedDate)
                          )
                        ).format("YYYY-MM-DD")}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        // selected={this.state.SelectedFromDate}
                        onChange={this.handleHKCFromDateChange}
                        open={this.state.hkcFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "top-end" : "bottom"}`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openHKCFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">HKC Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.hkcExpiryDate && Moment(
                          new Date(
                            Date.parse(this.state.shipData.hkcExpiryDate)
                          )
                        ).format("YYYY-MM-DD")}
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        // selected={this.state.SelectedToDate}
                        onChange={this.handleHKCToDateChange}
                        open={this.state.hkcToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openHKCToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EUSSR Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={this.state.shipData.euSSRIssuedDate ? Moment(
                          new Date(
                            Date.parse(this.state.shipData.euSSRIssuedDate)
                          )
                        ).format("YYYY-MM-DD") : ""}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        // selected={this.state.SelectedFromDate}
                        onChange={this.handleEUSSRFromDateChange}
                        open={this.state.eussrFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "bottom-start" : "bottom"}`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openEUSSRFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EUSSR Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.euSSRExpiryDate ? Moment(
                          new Date(
                            Date.parse(this.state.shipData.euSSRExpiryDate)
                          )
                        ).format("YYYY-MM-DD") : ""}
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        // selected={this.state.SelectedToDate}
                        onChange={this.handleEUSSRToDateChange}
                        open={this.state.eussrToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openEUSSRToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6" : "col-lg-4"}
                    style={{ minWidth: "19%" }}
                  >
                    <label className="form-label">
                      Full Manual Issued Date
                    </label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={this.state.shipData.fullmannualIssuedDate ? Moment(
                          new Date(
                            Date.parse(
                              this.state.shipData.fullmannualIssuedDate
                            )
                          )
                        ).format("YYYY-MM-DD") : ''}
                        type="text"
                        placeholder="Issued Date"
                        className="form-control date-picker"
                        name="POFromDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        // selected={this.state.SelectedToDate}
                        onChange={this.handleIHMFromDateChange}
                        open={this.state.ihmFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openIHMFromDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Flag SOC </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Choose file
                          <input
                            type="file"
                            style={{ marginRight: 40 }}
                            id="files"
                            name="SOC"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.flagSocFilename}
                      />
                      {this.state.flagSocFilename ? (
                        <div class="input-group-append" style={{ cursor: "pointer" }}>
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearSOC()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">IAPP </label>
                    <br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Choose file
                          <input
                            type="file"
                            id="files"
                            style={{ marginRight: 40 }}
                            name="IAPP"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="No file chosen"
                        value={this.state.iappFilename}
                      />
                      {this.state.iappFilename !== "" ? (
                        <div className="input-group-append" style={{ cursor: "pointer" }}>
                          <i
                            className="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearIAPP()}
                          ></i>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Exemption Certificate </label><br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="ec" onChange={e => this.handleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                      </div>
                      <input type="text" className="form-control" placeholder="No file chosen" value={this.state.ecFilename} />
                      {this.state.ecFilename !== "" ?
                        <div className="input-group-append" style={{ cursor: "pointer" }}>
                          <i className="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.Clearec()}></i>
                        </div> : null}
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">Flag SOC Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={
                          this.state.shipData.flagIssuedDate
                            ? Moment(
                              new Date(
                                Date.parse(this.state.shipData.flagIssuedDate)
                              )
                            ).format("YYYY-MM-DD")
                            : ""
                        }
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleFlagSocFromDateChange}
                        open={this.state.flagSocFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "bottom-start" : "bottom"}`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openFlagSocFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">Flag SOC Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={
                          this.state.shipData.flagExpiryDate
                            ? Moment(
                              new Date(
                                Date.parse(this.state.shipData.flagExpiryDate)
                              )
                            ).format("YYYY-MM-DD")
                            : ""
                        }
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        onChange={this.handleFlagSocToDateChange}
                        open={this.state.flagSocToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openFlagSocToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">IAPP Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        value={
                          this.state.shipData.iappIssuedDate
                            ? Moment(
                              new Date(
                                Date.parse(this.state.shipData.iappIssuedDate)
                              )
                            ).format("YYYY-MM-DD")
                            : ""
                        }
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        name="POFromDate"
                      ></input>
                      <DatePicker
                        onChange={this.handleiappFromDateChange}
                        open={this.state.iappFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "bottom-start" : "bottom"}`}
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openiappFromDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">IAPP Expiry Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        value={
                          this.state.shipData.iappExpiryDate
                            ? Moment(
                              new Date(
                                Date.parse(this.state.shipData.iappExpiryDate)
                              )
                            ).format("YYYY-MM-DD")
                            : ""
                        }
                        type="text"
                        placeholder="Expiry Date"
                        className="form-control date-picker"
                        name="POToDate"
                        data-date-format="yyyy-mm-dd"
                      />
                      <DatePicker
                        onChange={this.handleiappToDateChange}
                        open={this.state.iappToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openiappToDatePicker}
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EC Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"  >
                      <input
                        type="text"
                        value={this.state.shipData.ecIssuedDate ? Moment(
                          new Date(
                            Date.parse(this.state.shipData.ecIssuedDate)
                          )
                        ).format("YYYY-MM-DD")
                          : ""}
                        className="form-control date-picker"
                        placeholder="Issued Date"
                        data-date-format="yyyy-mm-dd"
                        name="POFromDate" ></input>
                      <DatePicker
                        onChange={this.handleecFromDateChange}
                        open={this.state.ecFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "bottom-start" : "bottom"}`}
                        className="form-control date-picker w-5 hide-date" />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openecFromDatePicker}
                      >
                        <button className="btn btn-default" style={{ height: "100%" }}>
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-3" : "col-lg-2"}>
                    <label className="form-label">EC Valid Till</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"  >
                      <input
                        type="text"
                        value={this.state.shipData.ecExpiryDate ? Moment(
                          new Date(
                            Date.parse(this.state.shipData.ecExpiryDate)
                          )
                        ).format("YYYY-MM-DD")
                          : ""}
                        className="form-control date-picker"
                        placeholder="Valid Till"
                        data-date-format="yyyy-mm-dd"
                        name="POFromDate" ></input>
                      <DatePicker
                        onChange={this.handleecToDateChange}
                        open={this.state.ecToDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date" />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openecToDatePicker}
                      >
                        <button className="btn btn-default" style={{ height: "100%" }}>
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Last Drydock Asbestos Free Declaration </label><br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="ldafd" onChange={e => this.handleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                      </div>
                      <input type="text" className="form-control" placeholder="No file chosen" value={this.state.ldafdFilename} />
                      {this.state.ldafdFilename !== "" ?
                        <div className="input-group-append" style={{ cursor: "pointer" }}>
                          <i className="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.Clearldafd()}></i>
                        </div> : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Asbestos Management Plan </label><br></br>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="amp" onChange={e => this.handleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                      </div>
                      <input type="text" className="form-control" placeholder="No file chosen" value={this.state.ampFilename} />
                      {this.state.ampFilename !== "" ?
                        <div className="input-group-append" style={{ cursor: "pointer" }}>
                          <i className="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.Clearamp()}></i>
                        </div> : null}
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>

                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Last Drydock Asbestos Free Declaration Issued Date</label>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"  >
                      <input
                        type="text"
                        value={this.state.shipData.ldafdIssuedDate ? Moment(
                          new Date(
                            Date.parse(this.state.shipData.ldafdIssuedDate)
                          )
                        ).format("YYYY-MM-DD")
                          : ""}
                        className="form-control date-picker"
                        data-date-format="yyyy-mm-dd"
                        placeholder="Issued Date"
                        name="POFromDate" ></input>
                      <DatePicker
                        onChange={this.handleldafdFromDateChange}
                        open={this.state.ldafdFromDateOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date" />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openldafdFromDatePicker}
                      >
                        <button className="btn btn-default" style={{ height: "100%" }}>
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="search-filter-box pb-0">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Ship Contact Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Email</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="shipEmail"
                      placeholder="Ship Email"
                      value={this.state.shipData.shipEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Ship Contact Number 1</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="phone1"
                      placeholder="Ship Contact Number 1"
                      value={this.state.shipData.phone1}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Ship Contact Number 2</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="phone2"
                      placeholder="Ship Contact Number 2"
                      value={this.state.shipData.phone2}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Invoice Forwarding Email
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="invoiceForwardingEmail"
                      placeholder="Invoice Forwarding Email"
                      value={this.state.shipData.invoiceForwardingEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Vessel Group Email</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="vesselGroupEmail"
                      placeholder="Vessel Group Email"
                      value={this.state.shipData.vesselGroupEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Designated Person</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="designatedPerson"
                      placeholder="Designated Person"
                      value={this.state.shipData.designatedPerson}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="search-filter-box pb-0">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Company Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Company Name</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="clientName"
                      value={this.state.shipData.clientName}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Company Name</option>
                      {CompanyNames &&
                        CompanyNames.map((company) => (
                          <option value={company}>{company}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Fleet Manager</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="fleetManager"
                      value={this.state.fleetManager}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Fleet Manager</option>
                      {CompanyUsers &&
                        CompanyUsers.fleetManager.map((user1) => (
                          <option value={user1}>{user1}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Technical Superintendent
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="technicalSuperintendent"
                      value={this.state.technicalSuperintendent}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Technical Superintendent</option>
                      {CompanyUsers &&
                        CompanyUsers.superintendent.map((user2) => (
                          <option value={user2}>{user2}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Technical Executive</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="technicalExecutive"
                      value={this.state.technicalExecutive}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Technical Executive</option>
                      {CompanyUsers &&
                        CompanyUsers.technicalExecutive.map((user3) => (
                          <option value={user3}>{user3}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="search-filter-box pb-0">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      PO Purchase Orders
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box po-upload-section ">
                  <div className="col-lg-4">
                    <label className="form-label">Upload Po File : </label>
                    <br></br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Browse File
                          <input
                            type="file"
                            id="files"
                            title=" "
                            style={{ marginRight: 40 }}
                            name="poFile"
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="No file chosen"
                        value={this.state.poUploadFileName}
                      />
                      {this.state.poUploadFileName ? (
                        <div class="input-group-append" style={{ cursor: "pointer" }}>
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearInputPoFile()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div
                    className="search-btn-col"
                    style={{ textAlign: "end", marginRight: "2.3rem" }}
                  >
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="button"
                      onClick={(e) => this.UploadPoDetailsDocument(e)}
                    >
                      {" "}
                      Upload{" "}
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className="search-filter-box">
                                <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Contract</h5></div>
                                </div>
                                <div className="row search-filter-box">
                                    <div className="col-lg-4">
                                        <label className="form-label">Contract Name</label><br></br>
                                        <input className="form-control" name="contractName" value={this.state.contractName} placeholder="Contract Name" onChange={e => this.handleContractInputChange(e)} disabled></input>
                                    </div>
                                    <div className="col-lg-8">
                                        <label className="form-label">Contract Status</label><br></br>
                                        <div className="row col-sm-12">
                                            <div className="radio">
                                                <input type="radio" checked={this.state.Pending} value="Pending" onChange={e => this.handleContractInputChange(e)} disabled={this.state.Pending ? false : true}></input>
                                                <span className="ml-1 mr-3">Pending</span>
                                            </div>
                                            <div className="radio">
                                                <input type="radio" checked={this.state.Active} value="Active" onChange={e => this.handleContractInputChange(e)} disabled={this.state.Active ? false : true}></input>
                                                <span className="ml-1 mr-3">Active</span>
                                            </div>
                                            <div className="radio">
                                                <input type="radio" checked={this.state.Terminated} value="Terminated" onChange={e => this.handleContractInputChange(e)} disabled={this.state.Terminated ? false : true}></input>
                                                <span className="ml-1 mr-3">Terminated</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5 className="card-title m-2" style={{ color: "092a51" }}>
                      Hazardous Materials
                    </h5>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 ml-4">
                      <label className="form-label">
                        Upload Revision Document :{" "}
                      </label>
                      <br></br>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            Browse File
                            <input
                              type="file"
                              id="files"
                              title=" "
                              style={{ marginRight: 40 }}
                              name="fileName"
                              onChange={(e) => this.handleInputChange(e)}
                              onClick={(event) => {
                                event.currentTarget.value = null;
                              }}
                            />
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="No file chosen"
                          value={this.state.revisionFilename}
                        />
                        {this.state.revisionFilename ? (
                          <div class="input-group-append" style={{ cursor: "pointer" }}>
                            <i
                              class="fa fa-times input-group-text"
                              aria-hidden="true"
                              onClick={() => this.ClearInput()}
                            ></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 ml-4">
                      <label className="form-label">
                        Upload Inventory Data :{" "}
                      </label>
                      <br></br>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            Browse File
                            <input
                              type="file"
                              style={{ marginRight: 40 }}
                              id="files"
                              title=" "
                              name="inventoryName"
                              onChange={(e) => this.handleInputChange(e)}
                              onClick={(event) => {
                                event.currentTarget.value = null;
                              }}
                            />
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="No file chosen"
                          value={this.state.inventoryFilename}
                        />
                        <div class="input-group-append" style={{ cursor: "pointer" }} >
                          {this.state.inventoryFilename ? (
                            <i
                              class="fa fa-times input-group-text"
                              aria-hidden="true"
                              onClick={() => this.ClearInputs()}
                            ></i>

                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="search-filter-box pb-0">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Paint & Coating Systems
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(1)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderPaintCoating()}
                    </div>
                    {paintAndCoating && paintAndCoating.length ? (
                      <div
                        className="search-btn-col mt-3"
                        style={{ textAlign: "end", marginRight: "2.3rem" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.deleteAllPaint()}
                        >
                          {" "}
                          Delete All{" "}
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <div className="search-filter-box pb-0">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Equipment & Machinery
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(2)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderEquipmentMachinery()}
                    </div>
                    {equipmentAndMachinery && equipmentAndMachinery.length ? (
                      <div
                        className="search-btn-col mt-3"
                        style={{ textAlign: "end", marginRight: "2.3rem" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.deleteAllEquipment()}
                        >
                          {" "}
                          Delete All{" "}
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <div className="search-filter-box pb-0">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Structure & Hull
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(3)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderStructureHull()}
                    </div>
                    {structureAndHull && structureAndHull.length ? (
                      <div
                        className="search-btn-col mt-3"
                        style={{ textAlign: "end", marginRight: "2.3rem" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.deleteAllStructure()}
                        >
                          {" "}
                          Delete All{" "}
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <div className="search-filter-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2"
                          style={{ color: "092a51" }}
                        >
                          Stores
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.showRightPanel(4)}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderStores()}
                    </div>
                    {store && store.length ? (
                      <div
                        className="search-btn-col mt-3"
                        style={{ textAlign: "end", marginRight: "2.3rem" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.deleteAllStore()}
                        >
                          {" "}
                          Delete All{" "}
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <div className="row search-filter-box">
                    <div className="col-lg-12 pb-2">
                      <div className="search-btn-col" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="button"
                          onClick={() => this.AddInventory()}
                        >
                          {" "}
                          Add Inventory{" "}
                        </button>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                          type="submit"
                          onClick={() => this.ReviseData()}
                        >
                          {" "}
                          Revise{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-12 pb-2">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.postData()}
                    >
                      {" "}
                      Update{" "}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() =>
                        this.props.history.push("/Home/Management/Ship")
                      }
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderPaintCoating = () => {
    const { showSidePane, PaintCoatingList } = this.props;
    return (
      <>
        {PaintCoatingList && PaintCoatingList.length ? (
          PaintCoatingList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Application : </strong>
                              <span className="italicFont ">
                                {item.application}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(1, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(1, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.deletePaint(item)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {PaintCoatingList && PaintCoatingList.length ? (
                    <Paginator
                        first={this.state.activePagePaintCoating}
                        rows={this.state.rows}
                        totalRecords={PaintCoatingList ? PaintCoatingList.length : 0}
                        onPageChange={(e) => this.handlePaintCoatingPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
    // }) : null
  };
  renderEquipmentMachinery = () => {
    const { showSidePane, EquipmentMachineryList } = this.props;
    return (
      <>
        {EquipmentMachineryList && EquipmentMachineryList.length ? (
          EquipmentMachineryList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(2, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(2, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() =>
                              this.deleteEquipmentAndMachinery(item)
                            }
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {EquipmentMachineryList && EquipmentMachineryList.length ? (
                    <Paginator
                        first={this.state.activePageEquipment}
                        rows={this.state.rows}
                        totalRecords={EquipmentMachineryList ? EquipmentMachineryList.length : 0}
                        onPageChange={(e) => this.handleEquipmentPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
  };
  renderStructureHull = () => {
    const { showSidePane, StructureHullList } = this.props;
    return (
      <>
        {StructureHullList && StructureHullList.length ? (
          StructureHullList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(3, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(3, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.deleteStructureAndHull(item)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {StructureHullList && StructureHullList.length ? (
                    <Paginator
                        first={this.state.activePageStructure}
                        rows={this.state.rows}
                        totalRecords={StructureHullList ? StructureHullList.length : 0}
                        onPageChange={(e) => this.handleStructurePageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
  };
  renderStores = () => {
    const { showSidePane, StoreList } = this.props;
    return (
      <>
        {StoreList && StoreList.length ? (
          StoreList.map((item, index) => {
            return (
              <div
                className="card MM-card-content"
                style={{
                  backgroundColor: "#eee",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div className={`row `}>
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                          {/* </div>
                                            <div className="row"> */}
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-6 mb-1" : "col-sm-3"
                            }
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={showSidePane ? "col-sm-6" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"col-sm-3 col-md-2 col-2 col-m-auto"}>
                        {/* <div className="text-center">
                                                <i className="fa fa-edit fa-2x fa-lg click p-2 mr-3" aria-hidden="true" style={{ color: " #1E3A8A", marginLeft: '-15px' }} onClick={() => this.EditMaterials(4, item)}></i>
                                            </div> */}
                        <div className="text-center">
                          <i
                            className="fa fa-edit fa-2x fa-lg click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.EditMaterials(4, item)}
                          ></i>
                          <i
                            className="fa fa-trash fa-2x click p-2"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A" }}
                            onClick={() => this.deleteStore(item)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card mb-0"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Items</h6>
            </div>
          </div>
        )}

        {/* {StoreList && StoreList.length ? (
                    <Paginator
                        first={this.state.activePageStore}
                        rows={this.state.rows}
                        totalRecords={StoreList ? StoreList.length : 0}
                        onPageChange={(e) => this.handleStoresPageChange(e)}>
                    </Paginator>
                ) : (
                        <div className="card mb-0" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Items
                                </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
  };
  EditMaterials(id, item) {
    const { match } = this.props;
    this.props.dispatch({ type: "EditMaterial", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    if (id === 1) {
      this.props.dispatch({ type: "GetPaintCoatingDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/PaintCoating`
      );
    } else if (id === 2) {
      this.props.dispatch({ type: "GetEquipmentMachineryDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/EquipmentMachinery`
      );
    } else if (id === 3) {
      this.props.dispatch({ type: "GetStructureHullDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/StructureHull`
      );
    } else if (id === 4) {
      this.props.dispatch({ type: "GetStoreDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/Stores`
      );
    }
    window.scrollTo(0, 0);
  }

  deletePaint = (item) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            item.isDeletePermanently = true;
            item.isUpdated = false;
            let items = item;
            this.state.deleteInventories.paintAndCoating.push(items);
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getPaintCoating(id));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteAllPaint = () => {
    const { dispatch, match, PaintCoatingList } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete all ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.deleteInventories.paintAndCoating = PaintCoatingList.map(
              (f) => {
                let paint = {
                  paintAndCoatingId: f.paintAndCoatingId,
                  name: f.name,
                  application: f.application,
                  location: f.location,
                  material: f.material,
                  remarks: f.remarks,
                  quantity: f.quantity,
                  unit: f.unit,
                  pchmchm: f.pchmchm,
                  isDeleted: false,
                  isUpdated: false,
                  isDeletePermanently: true,
                  createdBy: user.email,
                  modifiedBy: user.email,
                };
                return paint;
              }
            );
            this.setState({});
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getPaintCoating(id));
                dispatch({
                  type: "DeleteAllInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteAllInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteEquipmentAndMachinery = (item) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            item.isDeletePermanently = true;
            item.isUpdated = false;
            let items = item;
            this.state.deleteInventories.equipmentAndMachinery.push(items);
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getEquipmentMachinery(id));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteAllEquipment = () => {
    const { dispatch, match, EquipmentMachineryList } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete all ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.deleteInventories.equipmentAndMachinery =
              EquipmentMachineryList.map((g) => {
                let equip = {
                  equipmentAndMachineryId: g.equipmentAndMachineryId,
                  name: g.name,
                  material: g.material,
                  location: g.location,
                  remarks: g.remarks,
                  parts: g.parts,
                  quantity: g.quantity,
                  unit: g.unit,
                  pchmchm: g.pchmchm,
                  isDeleted: false,
                  isUpdated: false,
                  isDeletePermanently: true,
                  createdBy: user.email,
                  modifiedBy: user.email,
                };
                return equip;
              });
            this.setState({});
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getEquipmentMachinery(id));
                dispatch({
                  type: "DeleteAllInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteAllInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteStructureAndHull = (item) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            item.isDeletePermanently = true;
            item.isUpdated = false;
            let items = item;
            this.state.deleteInventories.structureAndHull.push(items);
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getStructureAndHull(id));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteAllStructure = () => {
    const { dispatch, match, StructureHullList } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete all ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.deleteInventories.structureAndHull =
              StructureHullList.map((h) => {
                let structure = {
                  structureAndHullId: h.structureAndHullId,
                  name: h.name,
                  material: h.material,
                  location: h.location,
                  remarks: h.remarks,
                  parts: h.parts,
                  quantity: h.quantity,
                  unit: h.unit,
                  pchmchm: h.pchmchm,
                  isDeleted: false,
                  isUpdated: false,
                  isDeletePermanently: true,
                  createdBy: user.email,
                  modifiedBy: user.email,
                };
                return structure;
              });
            this.setState({});
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getStructureAndHull(id));
                dispatch({
                  type: "DeleteAllInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteAllInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteStore = (item) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            item.isDeletePermanently = true;
            item.isUpdated = false;
            let items = item;
            this.state.deleteInventories.store.push(items);
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getStores(id));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  deleteAllStore = () => {
    const { dispatch, match, StoreList } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete all ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.deleteInventories.store = StoreList.map((i) => {
              let store = {
                storeId: i.storeId,
                name: i.name,
                material: i.material,
                location: i.location,
                remarks: i.remarks,
                parts: i.parts,
                quantity: i.quantity,
                unit: i.unit,
                pchmchm: i.pchmchm,
                isDeleted: false,
                isUpdated: false,
                isDeletePermanently: true,
                createdBy: user.email,
                modifiedBy: user.email,
              };
              return store;
            });
            this.setState({});
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.deleteInventories)
              .then((response) => {
                dispatch(getStores(id));
                dispatch({
                  type: "DeleteAllInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteAllInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  showRightPanel(id) {
    const { match } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditMaterial", data: false });
    if (id === 1) {
      this.props.dispatch({ type: "GetPaintCoatingDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/PaintCoating`
      );
    } else if (id === 2) {
      this.props.dispatch({ type: "GetEquipmentMachineryDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/EquipmentMachinery`
      );
    } else if (id === 3) {
      this.props.dispatch({ type: "GetStructureHullDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/StructureHull`
      );
    } else if (id === 4) {
      this.props.dispatch({ type: "GetStoreDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/Stores`
      );
    }
    window.scrollTo(0, 0);
  }
  showEquipmentSidePane() {
    this.props.dispatch({ type: "editEquipment", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/Management/ShipEdit/Equipment");
  }
  EditEquipment() {
    this.props.dispatch({ type: "editEquipment", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/Management/ShipEdit/Equipment");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    HKCAttachment: state.MasterScreenReducer.HKCAttachment,
    EUSSRAttachment: state.MasterScreenReducer.EUSSRAttachment,
    FullManualAttachment: state.MasterScreenReducer.FullManualAttachment,
    FlagSOCAttachment: state.MasterScreenReducer.FlagSOCAttachment,
    IAPPAttachment: state.MasterScreenReducer.IAPPAttachment,
    ShipDetails: state.MasterScreenReducer.ShipDetails,
    CertificateDetails: state.MasterScreenReducer.CertificateDetails,
    AMPAttachment: state.MasterScreenReducer.AMPAttachment,
    ECAttachment: state.MasterScreenReducer.ECAttachment,
    LDSFAAttachment: state.MasterScreenReducer.LDSFAAttachment,
    LRForm: state.MasterScreenReducer.LRForm || "",
    InventoryPerson: state.MasterScreenReducer.InventoryPerson,
    showSidePane: state.SidePanReducer.sidePan,
    PaintAndCoatingList: state.MasterScreenReducer.PaintCoatingList || [],
    EquipmentAndMachineryList:
      state.MasterScreenReducer.EquipmentMachineryList || [],
    StructureAndHullList: state.MasterScreenReducer.StructureHullList || [],
    StoreAndList: state.MasterScreenReducer.StoreList || [],
    PaintCoatingList: state.MMPLDashboardReducer.PaintCoatingList || [],
    EquipmentMachineryList:
      state.MMPLDashboardReducer.EquipmentMachineryList || [],
    StructureHullList: state.MMPLDashboardReducer.StructureHullList || [],
    StoreList: state.MMPLDashboardReducer.StoreList || [],
    CompanyNames: state.MasterScreenReducer.CompanyNames,
    CompanyUsers: state.MasterScreenReducer.CompanyUsers,
    CompanyName: state.MasterScreenReducer.CompanyName,
    PaintCoating: state.MMPLDashboardReducer.PaintCoating,
    EquipmentMachinery: state.MMPLDashboardReducer.EquipmentMachinery,
    StructureAndHull: state.MMPLDashboardReducer.StructureAndHull,
    Store: state.MMPLDashboardReducer.Store,
    attachmentDetail: state.ShipViewReducer.attachmentDetail,
    inventoryDetail: state.ShipViewReducer.inventoryDetail,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementEditItem)
);
